import { css, etiColors, mediaQueries } from '@eti/styles';
import { StackedIcon } from '@eti/components';
import { Heading, Text, Stack, Inline } from '@etg/wings';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = css`
  height: 100%;
  padding: 1.25rem 1rem;
  width: 100%;

  @media ${mediaQueries.large.up} {
    padding-top: 4.5rem;
  }
`;
const innerWrapperStyles = css`
  background: ${etiColors.white};
  border-radius: 0.188rem;
  box-shadow: 0 0 0.5rem 0 rgb(0 0 0 / 12%);
  display: block;
  margin: 0 auto;
  max-width: 34.063rem;
  overflow: hidden;
  width: 100%;
`;
const headerStyles = css`
  background: ${etiColors.lightBlue};
  background: ${`linear-gradient(to bottom, ${etiColors.lightBlue} 0, ${etiColors.lightBlue} 3rem, ${etiColors.white} 3rem, ${etiColors.white} 3rem, ${etiColors.white} 3.125rem)`};
  display: flex;
  height: 3.875rem;
  padding-top: 1.313rem;
`;
const contentStyles = css`
  padding: 0.938rem;

  @media ${mediaQueries.large.up} {
    padding: 2.5rem;
    padding-top: 0.938rem;
  }
`;
const descriptionStyles = css`
  color: ${etiColors.black};
  font-size: 0.875rem;
  margin-bottom: 1rem;
  text-align: center;
`;
const iconStyles = css`
  flex: 1;
  margin: 0 2px;
  max-height: 33px;
  max-width: 30px;
`;
const SegmentPanel = _ref => {
  let {
    title,
    content,
    icons,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Stack, {
    className: wrapperStyles,
    children: /*#__PURE__*/_jsxs(Stack, {
      className: innerWrapperStyles,
      children: [/*#__PURE__*/_jsx(Inline, {
        align: "center",
        className: headerStyles,
        children: icons.map((stackedIcons, index) => /*#__PURE__*/_jsx(StackedIcon, {
          className: iconStyles,
          icons: stackedIcons
        }, `stacked-icon-${index}`))
      }), /*#__PURE__*/_jsxs(Stack, {
        align: "center",
        className: contentStyles,
        spacing: 8,
        children: [/*#__PURE__*/_jsx(Heading, {
          level: 3,
          children: title
        }), /*#__PURE__*/_jsx(Text, {
          className: descriptionStyles,
          children: content
        }), children]
      })]
    })
  });
};
export default SegmentPanel;
//# sourceMappingURL=SegmentPanel.js.map